export default __webpack_public_path__ + "a9e20c77feb219007920d773ba25a1c3.svg";